import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getRemoteConfig, activate } from "firebase/remote-config";


const firebaseConfig = {
  apiKey: "AIzaSyBAb0cU4T_du4G6s8mASSfdRLvwz8OCBNg",
  authDomain: "voicerecorder-f84a7.firebaseapp.com",
  projectId: "voicerecorder-f84a7",
  storageBucket: "voicerecorder-f84a7.firebasestorage.app",
  messagingSenderId: "402351019220",
  appId: "1:402351019220:web:09d85777b93aad06619741",
  measurementId: "G-4HV67C3HCP"
};

const firebaseApp = initializeApp(firebaseConfig);
// const analytics = getAnalytics(firebaseConfig);

const remoteConfig = getRemoteConfig(firebaseApp);
// console.log(remoteConfig,'remoteConfig')

remoteConfig.settings.minimumFetchIntervalMillis = 0 

// 3600000; // Fetch every hour
remoteConfig.defaultConfig = {
  welcome_message: "Welcome to our app!",
};

export { firebaseApp, remoteConfig, };